// extracted by css-extract-rspack-plugin
export default {"copyIcon":"copyIcon-yDhMXF","button":"button-OTHLhm"};